import http from './http';

export interface Settings {
  _id?: string;
  platformName: string;
  platformLogo: string;
  platformTagline: string;
  primaryColor: string;
  footerText: string;
  heroTitle: string;
  heroDescription: string;
  primaryButtonText: string;
  primaryButtonLink: string;
  secondaryButtonText: string;
  secondaryButtonLink: string;
}

export const getSettings = async (): Promise<Settings> => {
  const { data } = await http.get<Settings>('/settings');
  return data;
};

export const updateSettings = async (settings: Partial<Settings>, token: string): Promise<Settings> => {
  const { data } = await http.put<Settings>('/settings', settings, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return data;
};

